<template>
  <div class="event-child">
    <Candidates
      v-if="election.questionnaire && election.questionnaire.length > 0"
      v-model="election.questionnaire"
      :maxChoices="election.max_choices"
     ></Candidates>
  </div>
</template>

<script>
import Candidates from '@/components/Elections/Candidates.vue'

export default {
  name: 'ElectionVoting',

  components: { Candidates },

  computed: {
    election () {
      return this.$store.getters.election
    }
  },

  methods: {
  }
}
</script>
